









import React, { useState, useRef, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, Card, CardContent, Button, Box } from "@mui/material";
import axios from 'axios';
import ScreenLayoutServices from "../../services/externalServices/TicketServices/screenLayoutServices";

import InfoIcon from '@mui/icons-material/Info';
import { Tooltip, IconButton } from '@mui/material'; // if not already imported


// Add at the top with other imports
import { useContext } from 'react';
import { BookingContext } from '../../../context/BookingContext'
import BookingBreadcrumb from "../components/BookingBreadcrumb";
const BookedSeats = () => {
  const location = useLocation();
  const { date, time, theatreId, maxTimeLimit, showtimeId, movie, nameOfTheatre, code, forceReload = false,isSectionLayout } = location.state;

  console.log('movie content check details in the booked seats=====', showtimeId, time);

  const [seatLayout, setSeatLayout] = useState(location.state.seatLayout || [])
  // const [seatLayout, setSeatLayout] = useState({ seatLayout: [] }); // empty default structure

  const [showModal, setShowModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('')
  const [pendingPayload, setPendingPayload] = useState(null); // For storing validated booking payload


  const [zoom, setZoom] = useState(0.8);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [selectedSeatsDetails, setSelectedSeatsDetails] = useState([]);
  const [selectedSeatsCount, setSelectedSeatsCount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const layoutRef = useRef(null);
  const navigate = useNavigate();



  // const { forceReload, seatLayout: initialSeatLayout } = location.state;
  // Add timestamp for cache validation
  const [lastUpdated, setLastUpdated] = useState(Date.now());

  const [showInfoModal, setShowInfoModal] = useState(false);


  const MAX_SEATS = 5;

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.2, 2));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.2, 0.5));


  // Context

  const { needsRefresh, setNeedsRefresh } = useContext(BookingContext);

  console.log('value of the needsRefresh', needsRefresh);
  const { firstname, role = "", accessList = [], _id } = JSON.parse(localStorage.getItem("admin"));



  const [loading, setLoading] = useState(true);
  // At the top of your component (or just before return)
  const loadingLayout =
    !seatLayout?.seatLayout ||
    !Array.isArray(seatLayout.seatLayout) ||
    seatLayout.seatLayout.length === 0;




    console.log('isSectionLayout==========in BookedSeats===========',isSectionLayout);

  useEffect(() => {
    // This runs on mount, and anytime dependencies (ids, date, time) change (remounts)
    async function fetchLayout() {
      setLoading(true);
      const data = {
        theatreId,
        date,
        time,
        showtimeId
      };
      try {
        const seatLayout = await ScreenLayoutServices.getBookedScreenLayout(data);
        setSeatLayout(seatLayout);
      } catch (e) {
        setSeatLayout({ seatLayout: [] });
      }
      setLoading(false);
    }
    fetchLayout();
  }, [theatreId, date, time, showtimeId]);


  useEffect(() => {
    const fetchData = async () => {
      if (needsRefresh) {

        // fetchUpdatedLayout(true);
        await fetchUpdatedLayout();
        setNeedsRefresh(false);
      }
    }
    fetchData();
  }, [needsRefresh]);


  const handleWheel = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    e.preventDefault();
    if (e.deltaY < 0) {
      setZoom(prev => Math.min(prev + 0.1, 2));
    } else {
      setZoom(prev => Math.max(prev - 0.1, 0.5));
    }
  };

  useEffect(() => {
    const refCurrent = layoutRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("wheel", handleWheel, { passive: false });
    }
    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);



  // // Fetch updated layout when component mounts or when forceReload changes
  // useEffect(() => {
  //   const fetchData = async () => {
  //     console.log('the value of the forceReload', forceReload)
  //     if (forceReload) {
  //       console.log('in the forcereload==========================', forceReload)
  //       await handleBlockSeat();
  //     } else {
  //       // Try to get cached layout first
  //       const cachedLayout = localStorage.getItem(
  //         `seatLayout_${theatreId}_${showtimeId}_${date}_${time}`
  //       );
  //       if (cachedLayout) {
  //         setSeatLayout(JSON.parse(cachedLayout));
  //       }
  //     }
  //   };

  //   fetchData();
  // }, [forceReload, theatreId, showtimeId, date, time]);


  // Enhanced useEffect with dependencies
  // useEffect(() => {
  //   handleBlockSeat(location.state?.forceReload);
  // }, [theatreId, showtimeId, date, time, lastUpdated]);


  // useEffect(() => {
  //   if (forceReload) {
  //     fetchUpdatedLayout(); // this sets seatLayout with fresh data
  //   } else {
  //     setSeatLayout(initialSeatLayout || []);
  //   }
  // }, []);


  const handleSeatPress = (sectionIndex, rowIndex, colIndex, seat) => {
    // Ensure numeric values for sectionIndex and colIndex





    const numericSectionIndex = Number(sectionIndex);
    const numericColIndex = Number(colIndex);

    const seatId = `${numericSectionIndex}-${seat.Row}-${seat.Col}`;
    const isSelected = selectedSeats.includes(seatId);

    let updatedSelectedSeats;
    let updatedSelectedSeatsCount;
    let updatedSelectedSeatsDetails;

    if (isSelected) {
      updatedSelectedSeats = selectedSeats.filter((id) => id !== seatId);
      updatedSelectedSeatsCount = selectedSeatsCount - 1;
      updatedSelectedSeatsDetails = selectedSeatsDetails.filter((s) => s.id !== seatId);
    } else {
      if (selectedSeatsCount < MAX_SEATS) {
        updatedSelectedSeats = [...selectedSeats, seatId];
        updatedSelectedSeatsCount = selectedSeatsCount + 1;
        updatedSelectedSeatsDetails = [
          ...selectedSeatsDetails,
          {
            sectionIndex: numericSectionIndex,
            rowIndex,
            colIndex: numericColIndex,
            id: seatId,
            seat
          }
        ];
      } else {
        setErrorMessage('You can select a maximum of 5 seats.');
        return;
      }
    }

    const updatedSelectedSeatsDetailsWithNames = updatedSelectedSeatsDetails.map((detail) => {

      const section = seatLayout.seatLayout[detail.sectionIndex];

      console.log('section price and its fee', section.Price, section?.ConvenienceFee);
      const sectionName = section ? section.Name : 'Unknown Section';
      const sectionPrice = section.Price;
      const sectionCF = section?.ConvenienceFee;
      const seatNumber = `${detail.seat.Row}${detail.seat.Col}`;
      return {
        ...detail,
        sectionName,
        seatNumber,
        sectionPrice,
        sectionCF,
        // Ensure numeric values in the final payload
        sectionIndex: Number(detail.sectionIndex),
        // colIndex: Number(detail.colIndex)
        colIndex: Number(detail.colIndex) - 1,
      };
    });

    setSelectedSeats(updatedSelectedSeats);
    setSelectedSeatsCount(updatedSelectedSeatsCount);
    setSelectedSeatsDetails(updatedSelectedSeatsDetailsWithNames);

    let tp = 0;
    updatedSelectedSeatsDetailsWithNames.forEach((detail) => {
      const section = seatLayout.seatLayout[detail.sectionIndex];
      if (section) {

        const seatPrice = section.Price || 0;
        tp += seatPrice;
        // if (detail.sectionName === 'Upper Balcony') {
        //   tp += 100;
        // } else {
        //   const seatPrice = section.Price || 0;
        //   tp += seatPrice;
        // }
      }
    });

    setTotalPrice(tp);
    setErrorMessage('');
  };

  useEffect(() => {
    window.selectSeat = (sectionIndex, rowIndex, colIndex) => {
      const section = seatLayout.seatLayout[sectionIndex];
      const seat = section.Seats.find(s => s.Row === rowIndex && s.Col === colIndex);
      // if (seat && seat.Stat !== 2 && seat.Stat !== 3 && seat.Col !== "X" && seat.Stat !== 4) {
      // if (seat && seat.Stat !== 2 && seat.Stat !== 3 && seat.Col !== "X") {
      if (seat && seat.Stat !== 2 && seat.Stat !== 3 && seat.Stat !== 4 && seat.Col !== "X") {

        handleSeatPress(sectionIndex, rowIndex, colIndex, seat);
      }
    };
  }, [selectedSeats, selectedSeatsDetails]);




  const handleCancelBooking = () => {
    // Reset the selected seats and details
    setSelectedSeats([]);
    setSelectedSeatsCount(0);
    setSelectedSeatsDetails([]);
    setErrorMessage('Booking has been canceled. Please select seats again.');

    // Optional: Directly update UI elements or styles
    // Ensure that buttons or other UI elements react to the state reset
    // Example:
    const seatButtons = document.querySelectorAll('.seat-button');
    seatButtons.forEach(button => {
      button.classList.remove('selected');  // Reset any selected button classes
    });
  };





  // Working --- Till Now

  // const handleModalSubmit = (enteredPhone) => {
  //   setShowModal(false);

  //   if (!pendingPayload) return;

  //   // Add phone to the stored payload
  //   const finalPayload = {
  //     ...pendingPayload,
  //     lockedByPhoneNumber: enteredPhone
  //   };

  //   // ✅ Navigate to confirm screen
  //   navigate('/confirm-ticket', {
  //     state: {
  //       ...finalPayload,
  //       maxTimeLimit,
  //       code,
  //       totalPrice,
  //       movie,
  //       nameOfTheatre,
  //       previousPage: location.pathname,
  //       forceReload: true,
  //       passedPhoneNumber: enteredPhone
  //     }
  //   });
  // };



  // const handleConfirmBooking = async () => {
  //   console.log('Confirming booking...');

  //   const notForCruzeSeats = selectedSeatsDetails.filter((seatDetail) => seatDetail.seat.Stat === 0);

  //   if (notForCruzeSeats.length > 0) {
  //     const proceed = window.confirm("You have selected seats that are RESERVED. Do you still want to proceed with the booking?");
  //     if (!proceed) {
  //       setSelectedSeatsDetails([]);
  //       handleCancelBooking();
  //       setErrorMessage("");
  //       return;
  //     }
  //   }

  //   const cleanedSeats = selectedSeatsDetails.map((seatDetail) => {
  //     const { seat, ...rest } = seatDetail;
  //     const { Row, Col, Stat } = seat;
  //     return {
  //       ...rest,
  //       sectionCF: seatDetail.sectionCF, // ✅ Add this line
  //       seat: { Row, Col, Stat }
  //     };
  //   });




  //   console.log('cleaned seats========', cleanedSeats);

  //   const payload = {
  //     showtimeId,
  //     theatreId,
  //     bookedSeats: cleanedSeats,
  //     date,
  //     time,
  //     lockedById: _id,
  //     lockedByPhoneNumber: null
  //   };

  //   console.log('Booking payload:', payload.bookedSeats);

  //   try {


  //     const response = await ScreenLayoutServices.createScreenLayout(payload);

  //     // console.log('response in the BookedSeats', response.error);


  //     console.log('selected seat details in the booked seats===++++++++++++++++++++++++++++++', response);

  //     // Check for seat booking conflict

  //     if (response?.message == "One or more seats are already booked or blocked") {
  //       // alert("❌ Some of the selected seats were already booked by someone else. Please refresh and try again.");

  //       // alert("❌ ","Some of the selected seats were already booked by someone else. Please refresh and try again.");

  //       setErrorMessage("Some of the selected seats were already booked by someone else. Please refresh and try again.");


  //     // ⏳ Wait 5 seconds before refresh
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 5000);

  //       return; // Stop navigation
  //     }

  //     if (
  //       response?.message === 'Existing screen layout updated successfully' ||
  //       response?.message === 'New screen layout created successfully'
  //     ) {

  //       // const phone = prompt("Please enter your phone number (10 digits):");
  //       // if (!phone || phone.length !== 10) {
  //       //   alert("Invalid phone number. Please enter a 10-digit number.");
  //       //   return;
  //       // }

  //       setPendingPayload(payload);     // ✅ Store the validated payload
  //       setShowModal(true);
  //           // ✅ Show the modal
  //       // navigate('/confirm-ticket', {
  //       //   state: {
  //       //     showtimeId,
  //       //     theatreId,
  //       //     maxTimeLimit,
  //       //     code,
  //       //     bookedSeats: selectedSeatsDetails,
  //       //     date,
  //       //     time,
  //       //     totalPrice,
  //       //     movie,
  //       //     nameOfTheatre,
  //       //     previousPage: location.pathname,
  //       //     forceReload: true,
  //       //     passedPhoneNumber: phone // ✅ Pass phone number

  //       //   }
  //       // });
  //     } else {
  //       throw new Error('Failed to book seats');
  //     }

  //   } catch (error) {
  //     console.error('Error booking seats:', error);
  //     setErrorMessage('Something went wrong. Please try again.');

  //     // ⏳ Wait 5 seconds before refresh
  //     // setTimeout(() => {
  //     //   window.location.reload();
  //     // }, 5000);
  //   }
  // };












  const handleConfirmBooking = () => {
    console.log('Confirming booking...');

    const notForCruzeSeats = selectedSeatsDetails.filter(
      (seatDetail) => seatDetail.seat.Stat === 0
    );

    if (notForCruzeSeats.length > 0) {
      const proceed = window.confirm(
        "You have selected seats that are RESERVED. Do you still want to proceed with the booking?"
      );
      if (!proceed) {
        setSelectedSeatsDetails([]);
        handleCancelBooking();
        setErrorMessage("");
        return;
      }
    }

    const cleanedSeats = selectedSeatsDetails.map((seatDetail) => {
      const { seat, ...rest } = seatDetail;
      const { Row, Col, Stat } = seat;
      return {
        ...rest,
        sectionCF: seatDetail.sectionCF,
        seat: { Row, Col, Stat }
      };
    });

    const payload = {
      showtimeId,
      theatreId,
      bookedSeats: cleanedSeats,
      date,
      time,
      lockedById: _id,
      lockedByPhoneNumber: null, // will update later
      isAdmin: true // ✅ Simple and clear
    };

    // Store payload & open modal
    setPendingPayload(payload);
    setShowModal(true);
  };

  const handleModalSubmit = async (enteredPhone) => {
    setShowModal(false);

    if (!pendingPayload) return;

    const finalPayload = {
      ...pendingPayload,
      lockedByPhoneNumber: enteredPhone
    };

    try {
      const response = await ScreenLayoutServices.createScreenLayout(finalPayload);


      console.log('response=============', response);

      if (response?.message == "One or more seats are already booked or blocked") {
        setErrorMessage(
          "Some seats are no longer available. Refreshing in 5s."
        );
        setTimeout(() => window.location.reload(), 5000);
        return;
      }

      if (
        response?.message === 'Existing screen layout updated successfully' ||
        response?.message === 'New screen layout created successfully'
      ) {
        navigate('/confirm-ticket', {
          state: {
            ...finalPayload,
            maxTimeLimit,
            code,
            totalPrice,
            movie,
            nameOfTheatre,
            previousPage: location.pathname,
            forceReload: true,
            passedPhoneNumber: enteredPhone,
            isSectionLayout
          }
        });
      } else {
        throw new Error('Failed to book seats');
      }
    } catch (error) {
      console.error('Error booking seats:', error);
      setErrorMessage("Something went wrong. Refreshing in 5 seconds.");
      setTimeout(() => window.location.reload(), 5000);
    }
  };








  const fetchUpdatedLayout = async () => {
    try {

      console.log('entering the fetchUpdateLayout');


      const response = await ScreenLayoutServices.getBookedScreenLayout({
        theatreId,
        showtimeId,
        date,
        time
      });
      // const response = await axios.get('http://localhost:4123/api/bookedScreenLayout/getLayout', {
      //   params: {
      //     theatreId,
      //     showtimeId,
      //     date,
      //     time
      //   }
      // });
      console.log('entering the resposne', response);
      // });
      console.log('entering the resposne', response.data);
      if (response) {
        console.log('entering the resposne', response.data);

        // Update both state and localStorage
        const updatedLayout = response;

        localStorage.setItem(
          `seatLayout_${theatreId}_${showtimeId}_${date}_${time}`,
          JSON.stringify(response)
        );
        setSeatLayout(response);


        // Force state update
        setSeatLayout(prev => {
          // Add deep comparison if needed
          return JSON.stringify(prev) !== JSON.stringify(updatedLayout)
            ? updatedLayout
            : prev;
        });

        console.log('Seat ********************************layout updated with:', updatedLayout);

        console.log('updated layout')
        // setLastUpdated(Date.now()); // Trigger re-render
      }
    } catch (error) {
      console.error('Error fetching updated layout:', error);
    }
  };

  // const handleBlockSeat = async () => {
  //   try {
  //     const updatedLayouts = [];

  //     for (const seatDetail of selectedSeatsDetails) {
  //       const { seat, sectionName } = seatDetail;
  //       const payload = {
  //         theatreId,
  //         showtimeId,
  //         sectionName,
  //         seat: {
  //           Row: seat.Row,
  //           Col: seat.Col,
  //           Stat: seat.Stat,
  //         },
  //         date,
  //         time,
  //       };

  //       // const response = await axios.post(
  //       //   'http://localhost:4123/api/bookedScreenLayout/blockSeatForCruze',
  //       //   payload
  //       // );


  //       const response = await ScreenLayoutServices.blockSeatForCruze(payload)

  //       console.log('rsponse in the block seat$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$', response);

  //       // if (response.status === 200) {
  //       if (response) {
  //         // response?.seatLayout
  //         // updatedLayouts.push(response.data);
  //         // updatedLayouts.push(response?.seatLayout);
  //         updatedLayouts.push(response); // push only the object
  //       }
  //     }

  //     // After all seats are blocked, update the layout
  //     if (updatedLayouts.length > 0) {
  //       // Use the last response or merge all responses as needed
  //       setSeatLayout(updatedLayouts[updatedLayouts.length - 1]);

  //       // Alternative: Fetch fresh layout from server
  //       await fetchUpdatedLayout();

  //       setErrorMessage('Seats successfully blocked!');
  //       setSelectedSeats([]);
  //       setSelectedSeatsCount(0);
  //       setSelectedSeatsDetails([]);
  //     }


  //   } catch (error) {
  //     console.error('Error blocking seats:', error);
  //     setErrorMessage('Failed to block seats. Please try again.');
  //   }
  // };



  const handleBlockSeat = async () => {
    try {
      // ✅ Force fresh layout fetch (no cache)
      console.log('Fetching FRESH seat layout before reserving...');
      setLoading(true);

      // Force fresh data from server
      const freshLayoutResponse = await ScreenLayoutServices.getBookedScreenLayout({
        theatreId,
        date,
        time,
        showtimeId
      });

      console.log('freshLayoutResponse===========', freshLayoutResponse)

      if (freshLayoutResponse?.seatLayout) {
        setSeatLayout(freshLayoutResponse);
      }

      setLoading(false);

      // ✅ Check if ANY selected seat is already booked/blocked
      let conflictFound = false;
      let conflictSeat = '';
      let conflictStatus = '';

      for (const seatDetail of selectedSeatsDetails) {
        const { seat, sectionIndex } = seatDetail;

        const currentSection = freshLayoutResponse.seatLayout[sectionIndex];
        const currentSeat = currentSection?.Seats.find(s =>
          s.Row === seat.Row && s.Col === seat.Col
        );

        console.log(`🔍 Checking seat ${seat.Row}${seat.Col} - Current Status: ${currentSeat?.Stat}`);

        if (currentSeat) {
          if (currentSeat.Stat === 2) {
            conflictFound = true;
            conflictSeat = `${seat.Row}${seat.Col}`;
            conflictStatus = 'BOOKED by user';
            break;
          } else if (currentSeat.Stat === 3) {
            conflictFound = true;
            conflictSeat = `${seat.Row}${seat.Col}`;
            conflictStatus = 'BLOCKED';
            break;
          } else if (currentSeat.Stat === 4) {
            conflictFound = true;
            conflictSeat = `${seat.Row}${seat.Col}`;
            conflictStatus = 'RESERVED by Cruze';
            break;
          }
        }
      }

      // ✅ If any conflict found, stop and show detailed message
      if (conflictFound) {
        setErrorMessage(`❌ Cannot reserve! Seat ${conflictSeat} is already ${conflictStatus}. Please refresh the page.`);

        // Clear selections and refresh layout
        setSelectedSeats([]);
        setSelectedSeatsCount(0);
        setSelectedSeatsDetails([]);

        // Auto-refresh after 3 seconds
        setTimeout(() => {
          setErrorMessage('');
          window.location.reload();
        }, 3000);

        return;
      }

      console.log('✅ All selected seats are available. Proceeding with reservation...');

      // ✅ Proceed with reservation logic (your existing code)
      const updatedLayouts = [];

      for (const seatDetail of selectedSeatsDetails) {
        const { seat, sectionName } = seatDetail;
        const payload = {
          theatreId,
          showtimeId,
          sectionName,
          seat: {
            Row: seat.Row,
            Col: seat.Col,
            Stat: seat.Stat,
          },
          date,
          time,
        };

        const response = await ScreenLayoutServices.blockSeatForCruze(payload);
        if (response) {
          updatedLayouts.push(response);
        }
      }

      // Success handling
      if (updatedLayouts.length > 0) {
        setSeatLayout(updatedLayouts[updatedLayouts.length - 1]);

        // Fetch fresh layout again to confirm
        await fetchUpdatedLayout();

        setErrorMessage(`✅ ${selectedSeatsDetails.length} seat(s) successfully reserved!`);
        setSelectedSeats([]);
        setSelectedSeatsCount(0);
        setSelectedSeatsDetails([]);

        setTimeout(() => setErrorMessage(''), 3000);
      }

    } catch (error) {
      console.error('❌ Error reserving seats:', error);
      setErrorMessage('❌ Failed to reserve seats. Please try again.');
      setTimeout(() => setErrorMessage(''), 3000);
    }
  };






  const handleUnblockSeat = async () => {
    try {
      const updatedLayouts = [];

      for (const seatDetail of selectedSeatsDetails) {
        const { seat, sectionName } = seatDetail;
        const payload = {
          theatreId,
          showtimeId,
          sectionName,
          seat: {
            Row: seat.Row,
            Col: seat.Col,
            Stat: seat.Stat
          },
          date,
          time
        };

        // const response = await axios.post(
        //   'http://localhost:4123/api/bookedScreenLayout/unblockSeatForCruze',
        //   payload
        // );

        const response = await ScreenLayoutServices.unblockSeatForCruze(payload)


        console.log('response in the unblockseat', response);
        // console.log('response in the unblockseat', response.data);
        // console.log('response in the unblockseat', response.message);
        // console.log('response in the unblockseat', response.seatLayout);

        // if (response.status === 200) {
        if (response) {
          // updatedLayouts.push(response.data);
          updatedLayouts.push(response);
        }
      }

      // After all seats are unblocked, update the layout
      if (updatedLayouts.length > 0) {
        // Use the last response or merge all responses as needed
        setSeatLayout(updatedLayouts[updatedLayouts.length - 1]);

        // Alternative: Fetch fresh layout from server
        await fetchUpdatedLayout();

        setErrorMessage('Seats successfully unblocked!');
        setSelectedSeats([]);
        setSelectedSeatsCount(0);
        setSelectedSeatsDetails([]);
      }
    } catch (error) {
      console.error('Error unblocking seats:', error);
      setErrorMessage('Error occurred while unblocking seats.');
    }
  };


  // Calculate total booked seats across all sections
  const totalBookedSeats = seatLayout.seatLayout.reduce((total, section) => {
    const bookedSeatsInSection = section.Seats.filter(seat => seat.Stat === 2).length;
    return total + bookedSeatsInSection;
  }, 0);


  // working but after reload we are able to select the orange seat

  // const generateHTML = () => {
  //   const sectionsHTML = seatLayout.seatLayout
  //     .map((section, sectionIndex) => {
  //       const bookedSeats = section.Seats.filter(seat => seat.Stat === 2);
  //       // const bookedSeatsList = bookedSeats.map(seat => `${seat.Row}${seat.Col}`).join(', ');

  //       const rowsHTML = Array.from(new Set(section.Seats.map(seat => seat.Row)))
  //         .map((row) => {
  //           const seatsHTML = section.Seats.filter((seat) => seat.Row === row)
  //             .map((seat) => {
  //               let seatClass = "seat";
  //               if (seat.Col === "X") return `<div class="emptySpace"></div>`;
  //               if (seat.Stat === 0) seatClass += " notForCruzeSeat notForCruzeSeatText";
  //               else if (seat.Stat === 1) seatClass += " availableSeat availableSeatText";
  //               else if (seat.Stat === 2) seatClass += " bookedSeat bookedSeatText";
  //               else if (seat.Stat === 3) seatClass += " blockedSeat blockedSeatText";
  //               // else if (seat.Stat === 4) seatClass += " blockedSeat blockedSeatText";
  //               else if (seat.Stat === 4) seatClass += " cruzeBlockedSeat cruzeBlockedSeatText";
  //               else if (seat.Stat === 5) seatClass += " cruzeAdminSeat cruzeBlockedSeatText";

  //               const seatId = `${sectionIndex}-${seat.Row}-${seat.Col}`;
  //               if (selectedSeats.includes(seatId)) seatClass += " selectedSeat selectedSeatText";


  //               // const clickHandler = seat.Stat === 1 ? `onclick="window.selectSeat('${sectionIndex}', '${seat.Row}', '${seat.Col}')"` : "";

  //               // return `<div class="${seatClass}" ${clickHandler}>${seat.Col}</div>`;


  //               return `<div class="${seatClass}" onclick="window.selectSeat('${sectionIndex}', '${seat.Row}', '${seat.Col}')">${seat.Col}</div>`;
  //             })
  //             .join("");

  //           return `
  //             <div class="seat-row">
  //               <div class="row-id">${row}</div>
  //               ${seatsHTML}
  //             </div>
  //           `;
  //         })
  //         .join("");

  //       return `
  //         <div class="section-container">
  //           <div class="layout-name">
  //             ${section.Price === 0 ? section.Name : `Rs. ${section.Price} for ${section.Name}`}

  //           </div>
  //           <div class="divider"></div>
  //           <div class="seat-container">
  //             ${rowsHTML}
  //           </div>
  //         </div>
  //       `;
  //     })
  //     .join("");

  //   return `
  //     <html>
  //       <head>
  //         <style>
  //           @import url('https://fonts.googleapis.com/css2?family=Poppins');
  //           ${styles}
  //         </style>
  //       </head>
  //       <body>
  //         <div class="zoom-container" style="transform: scale(${zoom}); transform-origin: 0 0;">
  //           <div class="container">
  //             ${sectionsHTML}
  //             <div class="screen-text">Screen is here</div>
  //           </div>

  //         </div>
  //       </body>
  //     </html>
  //   `;
  // };










  // const generateHTML = () => {
  //   const sectionsHTML = seatLayout.seatLayout
  //     .map((section, sectionIndex) => {
  //       const rowsHTML = Array.from(new Set(section.Seats.map(seat => seat.Row)))
  //         .map((row) => {
  //           const seatsHTML = section.Seats.filter((seat) => seat.Row === row)
  //             .map((seat) => {
  //               let seatClass = "seat";
  //               if (seat.Col === "X") return `<div class="emptySpace"></div>`;
  //               if (seat.Stat === 0) seatClass += " notForCruzeSeat notForCruzeSeatText";
  //               else if (seat.Stat === 1) seatClass += " availableSeat availableSeatText";
  //               else if (seat.Stat === 2) seatClass += " bookedSeat bookedSeatText";
  //               else if (seat.Stat === 3) seatClass += " blockedSeat blockedSeatText";
  //               else if (seat.Stat === 4) seatClass += " cruzeBlockedSeat cruzeBlockedSeatText";
  //               else if (seat.Stat === 5) seatClass += " cruzeAdminSeat cruzeBlockedSeatText";

  //               const seatId = `${sectionIndex}-${seat.Row}-${seat.Col}`;
  //               if (selectedSeats.includes(seatId)) seatClass += " selectedSeat selectedSeatText";

  //               // ✅ FIXED: Only add click handler for selectable seats
  //               const isClickable = seat.Stat !== 2 && seat.Stat !== 3 && seat.Stat !== 4 && seat.Col !== "X";
  //               const clickHandler = isClickable 
  //                 ? `onclick="window.selectSeat('${sectionIndex}', '${seat.Row}', '${seat.Col}')"` 
  //                 : "";

  //               // ✅ Add cursor style based on clickability
  //               const cursorStyle = isClickable ? "cursor: pointer;" : "cursor: not-allowed;";

  //               return `<div class="${seatClass}" ${clickHandler} style="${cursorStyle}">${seat.Col}</div>`;
  //             })
  //             .join("");

  //           return `
  //             <div class="seat-row">
  //               <div class="row-id">${row}</div>
  //               ${seatsHTML}
  //             </div>
  //           `;
  //         })
  //         .join("");

  //       return `
  //         <div class="section-container">
  //           <div class="layout-name">
  //             ${section.Price === 0 ? section.Name : `Rs. ${section.Price} for ${section.Name}`}
  //           </div>
  //           <div class="divider"></div>
  //           <div class="seat-container">
  //             ${rowsHTML}
  //           </div>
  //         </div>
  //       `;
  //     })
  //     .join("");

  //   return `
  //     <html>
  //       <head>
  //         <style>
  //           @import url('https://fonts.googleapis.com/css2?family=Poppins');
  //           ${styles}
  //         </style>
  //       </head>
  //       <body>
  //         <div class="zoom-container" style="transform: scale(${zoom}); transform-origin: 0 0;">
  //           <div class="container">
  //             ${sectionsHTML}
  //             <div class="screen-text">Screen is here</div>
  //           </div>
  //         </div>
  //       </body>
  //     </html>
  //   `;
  // };











  // const generateHTML = () => {
  //   const sectionsHTML = seatLayout.seatLayout
  //     .map((section, sectionIndex) => {
  //       const rowsHTML = Array.from(new Set(section.Seats.map(seat => seat.Row)))
  //         .map((row) => {
  //           const seatsHTML = section.Seats.filter((seat) => seat.Row === row)
  //             .map((seat) => {
  //               let seatClass = "seat";
  //               if (seat.Col === "X") return `<div class="emptySpace"></div>`;
  //               if (seat.Stat === 0) seatClass += " notForCruzeSeat notForCruzeSeatText";
  //               else if (seat.Stat === 1) seatClass += " availableSeat availableSeatText";
  //               else if (seat.Stat === 2) seatClass += " bookedSeat bookedSeatText";
  //               else if (seat.Stat === 3) seatClass += " blockedSeat blockedSeatText";
  //               else if (seat.Stat === 4) seatClass += " cruzeBlockedSeat cruzeBlockedSeatText";
  //               else if (seat.Stat === 5) seatClass += " cruzeAdminSeat cruzeBlockedSeatText";

  //               const seatId = `${sectionIndex}-${seat.Row}-${seat.Col}`;
  //               if (selectedSeats.includes(seatId)) seatClass += " selectedSeat selectedSeatText";

  //               // ✅ Only add click handler for selectable seats
  //               const isClickable = seat.Stat !== 2 && seat.Stat !== 3 && seat.Stat !== 4 && seat.Col !== "X";
  //               const clickHandler = isClickable
  //                 ? `onclick="window.selectSeat('${sectionIndex}', '${seat.Row}', '${seat.Col}')"`
  //                 : "";

  //               // ✅ Add cursor style based on clickability
  //               const cursorStyle = isClickable ? "cursor: pointer;" : "cursor: not-allowed;";

  //               // ✅ Add tooltip for blocked seats (Stat: 3)
  //               // let tooltipAttribute = "";
  //               // if (seat.Stat === 3 && seat.lockedByPhoneNumber) {
  //               //   tooltipAttribute = `title="Locked by: ${seat.lockedByPhoneNumber}"`;
  //               // }



  //               // ✅ Add tooltip for blocked seats (Stat: 3) with IST time
  //               let tooltipAttribute = "";
  //               if (seat.Stat === 3) {
  //                 const phoneNumber = seat.lockedByPhoneNumber || "Unknown";

  //                 // Convert UTC to IST format
  //                 let blockedUntilIST = "Unknown";
  //                 if (seat.blockedUntil) {
  //                   const utcDate = new Date(seat.blockedUntil);
  //                   // Convert to IST (Asia/Kolkata timezone)
  //                   blockedUntilIST = utcDate.toLocaleString("en-IN", {
  //                     timeZone: "Asia/Kolkata",
  //                     year: "numeric",
  //                     month: "2-digit",
  //                     day: "2-digit",
  //                     hour: "2-digit",
  //                     minute: "2-digit",
  //                     second: "2-digit",
  //                     hour12: true
  //                   });
  //                 }

  //                 tooltipAttribute = `title="Locked by: ${phoneNumber}&#10;Until: ${blockedUntilIST} IST"`;
  //               }


  //               return `<div class="${seatClass}" ${clickHandler} ${tooltipAttribute} style="${cursorStyle}">${seat.Col}</div>`;
  //             })
  //             .join("");

  //           return `
  //             <div class="seat-row">
  //               <div class="row-id">${row}</div>
  //               ${seatsHTML}
  //             </div>
  //           `;
  //         })
  //         .join("");

  //       return `
  //         <div class="section-container">
  //           <div class="layout-name">
  //             ${section.Price === 0 ? section.Name : `Rs. ${section.Price} for ${section.Name}`}
  //           </div>
  //           <div class="divider"></div>
  //           <div class="seat-container">
  //             ${rowsHTML}
  //           </div>
  //         </div>
  //       `;
  //     })
  //     .join("");

  //   return `
  //     <html>
  //       <head>
  //         <style>
  //           @import url('https://fonts.googleapis.com/css2?family=Poppins');
  //           ${styles}
  //           ${tooltipStyles} /* ✅ Add tooltip styles here in the CSS section */
  //         </style>
  //       </head>
  //       <body>
  //         <div class="zoom-container" style="transform: scale(${zoom}); transform-origin: 0 0;">
  //           <div class="container">
  //             ${sectionsHTML}
  //             <div class="screen-text">Screen is here</div>
  //           </div>
  //         </div>
  //       </body>
  //     </html>
  //   `;
  // };









  // ✅ Remove or comment out the tooltipStyles completely
  // const tooltipStyles = `...` // Remove this entire block

  const generateHTML = () => {
    const sectionsHTML = seatLayout.seatLayout
      .map((section, sectionIndex) => {
        const rowsHTML = Array.from(new Set(section.Seats.map(seat => seat.Row)))
          .map((row) => {
            const seatsHTML = section.Seats.filter((seat) => seat.Row === row)
              .map((seat) => {
                let seatClass = "seat";
                if (seat.Col === "X") return `<div class="emptySpace"></div>`;
                if (seat.Stat === 0) seatClass += " notForCruzeSeat notForCruzeSeatText";
                else if (seat.Stat === 1) seatClass += " availableSeat availableSeatText";
                else if (seat.Stat === 2) seatClass += " bookedSeat bookedSeatText";
                else if (seat.Stat === 3) seatClass += " blockedSeat blockedSeatText";
                else if (seat.Stat === 4) seatClass += " cruzeBlockedSeat cruzeBlockedSeatText";
                else if (seat.Stat === 5) seatClass += " cruzeAdminSeat cruzeBlockedSeatText";

                const seatId = `${sectionIndex}-${seat.Row}-${seat.Col}`;
                if (selectedSeats.includes(seatId)) seatClass += " selectedSeat selectedSeatText";

                const isClickable = seat.Stat !== 2 && seat.Stat !== 3 && seat.Stat !== 4 && seat.Col !== "X";
                const clickHandler = isClickable
                  ? `onclick="window.selectSeat('${sectionIndex}', '${seat.Row}', '${seat.Col}')"`
                  : "";

                const cursorStyle = isClickable ? "cursor: pointer;" : "cursor: not-allowed;";

                // ✅ Simple tooltip - only title attribute (no custom CSS)
                let tooltipAttribute = "";
                if (seat.Stat === 3) {
                  const phoneNumber = seat.lockedByPhoneNumber || "Unknown";

                  let blockedUntilIST = "Unknown";
                  if (seat.blockedUntil) {
                    const utcDate = new Date(seat.blockedUntil);
                    blockedUntilIST = utcDate.toLocaleString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true
                    });
                  }

                  // ✅ Use line break character for multiline tooltip
                  tooltipAttribute = `title="Locked by: ${phoneNumber}\nUntil: ${blockedUntilIST} IST"`;
                }

                return `<div class="${seatClass}" ${clickHandler} ${tooltipAttribute} style="${cursorStyle}">${seat.Col}</div>`;
              })
              .join("");

            return `
            <div class="seat-row">
              <div class="row-id">${row}</div>
              ${seatsHTML}
            </div>
          `;
          })
          .join("");

        return `
        <div class="section-container">
          <div class="layout-name">
            ${section.Price === 0 ? section.Name : `Rs. ${section.Price} for ${section.Name}`}
          </div>
          <div class="divider"></div>
          <div class="seat-container">
            ${rowsHTML}
          </div>
        </div>
      `;
      })
      .join("");

    return `
    <html>
      <head>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Poppins');
          ${styles}
         
        </style>
      </head>
      <body>
        <div class="zoom-container" style="transform: scale(${zoom}); transform-origin: 0 0;">
          <div class="container">
            ${sectionsHTML}
            <div class="screen-text">Screen is here</div>
          </div>
        </div>
      </body>
    </html>
  `;
  };








  const htmlContent = useMemo(() => generateHTML(), [seatLayout, selectedSeats, zoom]);








  const formattedDate = new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });





  const calculateContainerMinWidth = () => {
    let maxRowWidth = 0;

    seatLayout.seatLayout.forEach(section => {
      const rows = Array.from(new Set(section.Seats.map(seat => seat.Row)));

      rows.forEach(row => {
        const seatsInRow = section.Seats.filter(seat => seat.Row === row && seat.Col !== "X");
        const emptySpaces = section.Seats.filter(seat => seat.Row === row && seat.Col === "X").length;

        // Calculate width: seats + empty spaces + row-id + margins + padding
        const rowWidth = (seatsInRow.length * 33) + (emptySpaces * 33) + 35 + 40; // +40 for container padding
        maxRowWidth = Math.max(maxRowWidth, rowWidth);
      });
    });

    // Add extra space for zoom and margins
    return Math.max(maxRowWidth + 100, 800); // minimum 800px width
  };

  // Then use it in your styles
  const containerMinWidth = calculateContainerMinWidth();




  // return (
  //   <Card style={{ marginBottom: "20px" }}>
  //     <CardContent>
  //       {/* <Typography variant="h6" gutterBottom>Seat Layout</Typography> */}

  //       {/* Combined Zoom Controls and Legend in one line */}


  //       <Box sx={{
  //         display: 'flex',
  //         flexWrap: 'wrap',
  //         alignItems: 'center',
  //         gap: 2,
  //         mb: 2,
  //         justifyContent: 'space-between',
  //         width: '100%',
  //         maxWidth: '100%',
  //         overflow: 'hidden',
  //         boxSizing: 'border-box'
  //       }}>
  //         {/* Zoom Controls */}
  //         {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
  //           <Typography variant="body2" sx={{ mr: 1 }}>Zoom:</Typography>
  //           <Button variant="outlined" onClick={handleZoomOut} size="small" sx={{ minWidth: 32 }}>-</Button>
  //           <Button variant="outlined" onClick={handleZoomIn} size="small" sx={{ minWidth: 32, ml: 1 }}>+</Button>
  //         </Box> */}



  //         <Box
  //           sx={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             fontSize: '0.75rem', // smaller text
  //             px: 0.5,
  //             py: 0.25,
  //           }}
  //         >
  //           <Typography variant="body2" sx={{ mr: 0.5, fontSize: '0.75rem' }}>
  //             Zoom:
  //           </Typography>
  //           <Button
  //             variant="outlined"
  //             onClick={handleZoomOut}
  //             size="small"
  //             sx={{
  //               minWidth: 24,
  //               px: 0.5,
  //               fontSize: '0.75rem',
  //               lineHeight: 1,
  //               height: 24,
  //             }}
  //           >
  //             -
  //           </Button>
  //           <Button
  //             variant="outlined"
  //             onClick={handleZoomIn}
  //             size="small"
  //             sx={{
  //               minWidth: 24,
  //               px: 0.5,
  //               fontSize: '0.75rem',
  //               lineHeight: 1,
  //               height: 24,
  //               ml: 0.5,
  //             }}
  //           >
  //             +
  //           </Button>
  //         </Box>



  //         <Box
  //           sx={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             flexGrow: 1,
  //             minWidth: 0,
  //             px: 2,
  //             justifyContent: 'center',
  //           }}
  //         >
  //           <Typography
  //             variant="body2"
  //             sx={{
  //               fontWeight: 400,
  //               color: 'black',
  //               whiteSpace: { xs: 'normal', sm: 'nowrap' }, // Allow wrapping on mobile
  //               overflow: 'hidden',
  //               textOverflow: 'ellipsis',
  //               textAlign: 'center',
  //               fontSize: { xs: '0.95rem', sm: '1rem' }, // Slightly smaller font on mobile
  //             }}
  //           >
  //             {movie.name} | {formattedDate} | {time}
  //           </Typography>
  //         </Box>

  //         {/* Seat Legend - Compact version */}
  //         <Box sx={{
  //           display: 'flex',
  //           flexWrap: 'wrap',
  //           gap: 1,
  //           alignItems: 'center'
  //         }}>
  //           {[
  //             { color: 'white', border: 'green', label: 'Available' },
  //             { color: 'green', border: 'green', label: 'Selected' },
  //             { color: '#f1f1f1', border: '#f1f1f1', label: 'Booked' },
  //             { color: 'white', border: 'orange', label: 'Blocked' },
  //             { color: 'white', border: 'red', label: 'Reserved' },
  //             // { color: '#dbeafe', border: '#2563eb', label: 'Cruze'},
  //             // { color: '#fff3cd', border: '#ffca2c', label: 'Admin Only' }        // Stat = 5
  //             // { color: 'white', border: 'pink', label: 'Cruze' }
  //           ].map((item, index) => (
  //             <Box key={index} sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
  //               <Box sx={{
  //                 width: 16,
  //                 height: 16,
  //                 bgcolor: item.color,
  //                 border: `2px solid ${item.border}`,
  //                 borderRadius: '3px',
  //                 mr: 0.5
  //               }} />
  //               <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>{item.label}</Typography>
  //             </Box>
  //           ))}
  //         </Box>
  //       </Box>

  //       {/* Seat Layout Container */}
  //       <Box
  //         ref={layoutRef}
  //         sx={{
  //           overflow: "auto",
  //           width: "100%",
  //           height: "380px",
  //           border: "1px solid #ccc",
  //           // backgroundColor:'red',
  //           padding: "10px",

  //           '& .container': {
  //             // backgroundColor:'yellow',
  //             transform: 'scale(0.8)', // Initial zoom set to 80%
  //             transformOrigin: 'top left',
  //             // width: '80%',
  //             paddingLeft: '10px',
  //             // minWidth: '1200px',
  //             minWidth: `${containerMinWidth}px`,
  //             maxWidth: 'unset',
  //             paddingBottom: '50px',
  //             display: 'flex',
  //             flexDirection: 'column',
  //             alignItems: 'left'
  //           },
  //           '& .section-container': {
  //             width: '100%',
  //             maxWidth: '800px'
  //           }
  //         }}
  //         dangerouslySetInnerHTML={{ __html: htmlContent }}
  //       />

  //       {/* Selected Seats Info and Action Buttons */}





  //       <Box
  //         sx={{
  //           display: 'flex',
  //           flexDirection: { xs: 'column', sm: 'row' },
  //           alignItems: 'center',
  //           justifyContent: 'space-between',
  //           mt: 2,
  //           gap: 2,
  //         }}
  //       >
  //         {/* Left Side: Seat Summary + Reserve/Unblock */}
  //         <Box
  //           sx={{
  //             display: 'flex',
  //             flexDirection: { xs: 'column', sm: 'row' },
  //             alignItems: 'center',
  //             gap: 2,
  //             flex: 1,
  //           }}
  //         >
  //           <Typography variant="subtitle1">
  //             Booked: {totalBookedSeats} | Selected: {selectedSeatsCount} | Total: ₹{totalPrice}
  //           </Typography>

  //           <Box sx={{ display: 'flex', gap: 2 }}>
  //             <Button
  //               variant="contained"
  //               size="small"
  //               sx={{
  //                 backgroundColor: '#1976d2',
  //                 borderRadius: '12px',
  //                 px: 2,
  //                 textTransform: 'none',
  //                 fontWeight: 500,
  //                 fontSize: '0.875rem',
  //                 '&:hover': { backgroundColor: '#115293' },
  //               }}
  //               onClick={handleBlockSeat}
  //               disabled={selectedSeatsCount === 0}
  //             >
  //               Reserve
  //             </Button>

  //             <Button
  //               variant="contained"
  //               size="small"
  //               sx={{
  //                 backgroundColor: '#d32f2f',
  //                 borderRadius: '12px',
  //                 px: 2,
  //                 textTransform: 'none',
  //                 fontWeight: 500,
  //                 fontSize: '0.875rem',
  //                 '&:hover': { backgroundColor: '#9a0007' },
  //               }}
  //               onClick={handleUnblockSeat}
  //               disabled={selectedSeatsCount === 0}
  //             >
  //               Unblock
  //             </Button>
  //           </Box>
  //         </Box>

  //         {/* Right Side: Confirm Button */}
  //         <Box>
  //           <Button
  //             variant="contained"
  //             size="small"
  //             sx={{
  //               backgroundColor: '#000',
  //               borderRadius: '12px',
  //               px: 2,
  //               textTransform: 'none',
  //               fontWeight: 500,
  //               fontSize: '0.875rem',
  //               '&:hover': { backgroundColor: '#333' },
  //             }}
  //             onClick={handleConfirmBooking}
  //             disabled={selectedSeatsCount === 0}
  //           >
  //             Confirm
  //           </Button>
  //         </Box>
  //       </Box>






  //       {/* <Box sx={{
  //         display: 'flex',
  //         flexDirection: { xs: 'column', sm: 'row' },
  //         alignItems: 'center',
  //         justifyContent: 'space-between',
  //         mt: 2,
  //         gap: 2
  //       }}>
  //         <Typography variant="subtitle1">
  //           Booked: {totalBookedSeats} | Selected: {selectedSeatsCount} | Total: ₹{totalPrice}
  //         </Typography>

  //         <Button
  //             variant="contained"
  //             size="small"
  //             sx={{
  //               backgroundColor: '#1976d2',
  //               borderRadius: '12px',
  //               px: 2,
  //               textTransform: 'none',
  //               fontWeight: 500,
  //               fontSize: '0.875rem',
  //               '&:hover': { backgroundColor: '#115293' },
  //             }}
  //             onClick={handleBlockSeat}
  //             disabled={selectedSeatsCount === 0}
  //           >
  //             Reserve
  //           </Button>

  //           <Button
  //             variant="contained"
  //             size="small"
  //             sx={{
  //               backgroundColor: '#d32f2f',
  //               borderRadius: '12px',
  //               px: 2,
  //               textTransform: 'none',
  //               fontWeight: 500,
  //               fontSize: '0.875rem',
  //               '&:hover': { backgroundColor: '#9a0007' },
  //             }}
  //             onClick={handleUnblockSeat}
  //             disabled={selectedSeatsCount === 0}
  //           >
  //             Unblock
  //           </Button>

  //         <Box sx={{
  //           display: 'flex',
  //           gap: 2,
  //           flexWrap: 'wrap',
  //           justifyContent: 'center'
  //         }}>


  //           <Button
  //             variant="contained"
  //             size="small"
  //             sx={{
  //               backgroundColor: '#000',
  //               borderRadius: '12px',
  //               px: 2,
  //               textTransform: 'none',
  //               fontWeight: 500,
  //               fontSize: '0.875rem',
  //               '&:hover': { backgroundColor: '#333' },
  //             }}
  //             onClick={handleConfirmBooking}
  //             disabled={selectedSeatsCount === 0}
  //           >
  //             Confirm
  //           </Button>
  //         </Box>



  //       </Box> */}



  //       {errorMessage && (
  //         <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
  //           {errorMessage}
  //         </Typography>
  //       )}
  //     </CardContent>
  //     {showModal && (
  //       <TicketModal
  //         onClose={() => setShowModal(false)}
  //         onSubmit={handleModalSubmit}
  //         phoneNumber={phoneNumber}
  //         setPhoneNumber={setPhoneNumber}
  //       />
  //     )}


  //   </Card>
  // );

  // 1. Add this function in your component
  const copyToClipboard = () => {
    const supportInfo = `ScreenLayout ID: ${seatLayout._id || 'N/A'}
Theatre ID: ${theatreId || 'N/A'}
Showtime ID: ${showtimeId || 'N/A'}
Date: ${date || 'N/A'}
Time: ${time || 'N/A'}`;

    navigator.clipboard.writeText(supportInfo).then(() => {
      setErrorMessage('✅ Support info copied to clipboard!');
      setTimeout(() => setErrorMessage(''), 2000);
    });
  };



  return (
    <div className="mb-4">
      <div className="px-2">
        <BookingBreadcrumb currentStep="seats" />
      </div>
      <Card style={{ marginBottom: "20px" }}>
        <CardContent>
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 2,
          mb: 2,
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
          boxSizing: 'border-box'
        }}>
          {/* Zoom Controls */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '0.75rem',
              px: 0.5,
              py: 0.25,
            }}
          >
            <Typography variant="body2" sx={{ mr: 0.5, fontSize: '0.75rem' }}>
              Zoom:
            </Typography>
            <Button
              variant="outlined"
              onClick={handleZoomOut}
              size="small"
              sx={{
                minWidth: 24,
                px: 0.5,
                fontSize: '0.75rem',
                lineHeight: 1,
                height: 24,
              }}
            >
              -
            </Button>
            <Button
              variant="outlined"
              onClick={handleZoomIn}
              size="small"
              sx={{
                minWidth: 24,
                px: 0.5,
                fontSize: '0.75rem',
                lineHeight: 1,
                height: 24,
                ml: 0.5,
              }}
            >
              +
            </Button>
          </Box>

          {/* Movie Info with Info Button */}
          {/* Movie Info with Info Button */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexGrow: 1,
              minWidth: 0,
              px: 2,
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: 400,
                color: 'black',
                whiteSpace: { xs: 'normal', sm: 'nowrap' },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textAlign: 'center',
                fontSize: { xs: '0.95rem', sm: '1rem' },
              }}
            >
              {movie.name} | {formattedDate} | {time}
            </Typography>

            {/* Info Button */}
            {/* <Tooltip 
    title={
      <Box sx={{ p: 1 }}>
        <Typography variant="caption" sx={{ display: 'block', fontWeight: 'bold', mb: 1 }}>
          Support Information:
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
          Schedule ID: {seatLayout._id || 'N/A'}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
          Theatre ID: {theatreId || 'N/A'}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
          Showtime ID: {showtimeId || 'N/A'}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
          Date: {date || 'N/A'}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
          Time: {time || 'N/A'}
        </Typography>
      </Box>
    }
    placement="bottom"
  >
    <IconButton 
      size="small" 
      sx={{ 
        width: 20, 
        height: 20, 
        color: '#666',
        '&:hover': { color: '#1976d2' }
      }}
    >
      <InfoIcon sx={{ fontSize: '0.9rem' }} />
    </IconButton>
  </Tooltip> */}



            {/* // 2. Replace the info button with this */}
            {/* <IconButton
              size="small"
              onClick={copyToClipboard}
              title="Copy support info"
              sx={{
                width: 20,
                height: 20,
                color: '#666',
                '&:hover': { color: '#1976d2' }
              }}
            >
              <InfoIcon sx={{ fontSize: '0.9rem' }} />
            </IconButton> */}









            {/* Info Button with both tooltip and copy functionality */}
            <Tooltip
              title={
                <Box sx={{ p: 1 }}>
                  <Typography variant="caption" sx={{ display: 'block', fontWeight: 'bold', mb: 1 }}>
                    Support Information (Click to copy):
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
                    ScreenLayout ID: {seatLayout._id || 'N/A'}
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
                    Theatre ID: {theatreId || 'N/A'}
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
                    Showtime ID: {showtimeId || 'N/A'}
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
                    Date: {date || 'N/A'}
                  </Typography>
                  <Typography variant="caption" sx={{ display: 'block', fontFamily: 'monospace', fontSize: '0.7rem' }}>
                    Time: {time || 'N/A'}
                  </Typography>
                </Box>
              }
              placement="bottom"
              arrow
            >
              <IconButton
                size="small"
                onClick={copyToClipboard}
                sx={{
                  width: 20,
                  height: 20,
                  color: '#666',
                  '&:hover': { color: '#1976d2' }
                }}
              >
                <InfoIcon sx={{ fontSize: '0.9rem' }} />
              </IconButton>
            </Tooltip>

          </Box>


          {/* Seat Legend */}
          <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            alignItems: 'center'
          }}>
            {[
              { color: 'white', border: 'green', label: 'Available' },
              { color: 'green', border: 'green', label: 'Selected' },
              { color: '#f1f1f1', border: '#f1f1f1', label: 'Booked' },
              { color: 'white', border: 'orange', label: 'Blocked' },
              { color: 'white', border: 'red', label: 'Reserved' },
            ].map((item, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                <Box sx={{
                  width: 16,
                  height: 16,
                  bgcolor: item.color,
                  border: `2px solid ${item.border}`,
                  borderRadius: '3px',
                  mr: 0.5
                }} />
                <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>{item.label}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Seat Layout Container */}
        <Box
          ref={layoutRef}
          sx={{
            overflow: "auto",
            width: "100%",
            height: "380px",
            border: "1px solid #ccc",
            padding: "10px",
            '& .container': {
              transform: 'scale(0.8)',
              transformOrigin: 'top left',
              paddingLeft: '10px',
              minWidth: `${containerMinWidth}px`,
              maxWidth: 'unset',
              paddingBottom: '50px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left'
            },
            '& .section-container': {
              width: '100%',
              maxWidth: '800px'
            }
          }}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />

        {/* Selected Seats Info and Action Buttons */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: 2,
            gap: 2,
          }}
        >
          {/* Left Side: Seat Summary + Reserve/Unblock */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: 2,
              flex: 1,
            }}
          >
            <Typography variant="subtitle1">
              Booked: {totalBookedSeats} | Selected: {selectedSeatsCount} | Total: ₹{totalPrice}
            </Typography>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: '#1976d2',
                  borderRadius: '12px',
                  px: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  '&:hover': { backgroundColor: '#115293' },
                }}
                onClick={handleBlockSeat}
                disabled={selectedSeatsCount === 0}
              >
                Reserve
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: '#d32f2f',
                  borderRadius: '12px',
                  px: 2,
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  '&:hover': { backgroundColor: '#9a0007' },
                }}
                onClick={handleUnblockSeat}
                disabled={selectedSeatsCount === 0}
              >
                Unblock
              </Button>
            </Box>
          </Box>

          {/* Right Side: Confirm Button */}
          <Box>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: '#000',
                borderRadius: '12px',
                px: 2,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                '&:hover': { backgroundColor: '#333' },
              }}
              onClick={handleConfirmBooking}
              disabled={selectedSeatsCount === 0}
            >
              Confirm
            </Button>
          </Box>
        </Box>

        {errorMessage && (
          <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
            {errorMessage}
          </Typography>
        )}
        </CardContent>
        {showModal && (
          <TicketModal
            onClose={() => setShowModal(false)}
            onSubmit={handleModalSubmit}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
          />
        )}
      </Card>
    </div>
  );



};



const TicketModal = ({ onClose, onSubmit, setPhoneNumber, phoneNumber }) => {
  const [phoneError, setPhoneError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { if (inputRef.current) inputRef.current.focus(); }, []);

  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPhoneNumber(val);
    if (phoneError) setPhoneError('');
  };

  const handleSubmit = () => {
    if (!phoneNumber || phoneNumber.length !== 10) {
      setPhoneError('Enter a valid 10-digit number');
      return;
    }
    onSubmit(phoneNumber);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-sm">
        <h2 className="text-xl font-semibold mb-4">Enter Phone Number</h2>
        <div className="flex mb-4">
          <span className="px-3 py-2 bg-gray-100 border border-r-0 border-gray-300 rounded-l-md">+91</span>
          <input
            ref={inputRef}
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneChange}
            maxLength={10}
            inputMode="numeric"
            className={`border p-2 w-full rounded-md ${phoneError ? 'border-red-500' : 'border-gray-300'}`}
            placeholder="10-digit phone number"
          />
        </div>
        {phoneError && <p className="text-red-500 text-sm mb-3">{phoneError}</p>}
        <div className="flex justify-between">
          <button onClick={onClose} className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400">Cancel</button>
          <button onClick={handleSubmit} className="bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800">Confirm & Pay</button>
        </div>
      </div>
    </div>
  );
};

export default BookedSeats;

// .container {

//   background-color: rgba(250, 255, 255,0.5);
//   padding-bottom: 10px;

// }

const styles = `

  .zoom-container {
    display: inline-block;
    transition: transform 0.3s ease;
  }
  .section-container {
    margin-bottom: 20px;
    width: 100%;
    max-width: 800px; /* Adjust this value as needed */
  }
  .layout-name {
    padding: 0px 10px;
    font-size: 16px;
    color: #667085;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .booked-count {
    font-size: 14px;
    color: #ff0000;
  }
  .divider {
    border-bottom: 1px solid #ccc;
    margin: 15px 0;
  }
  .seat-container {
    padding: 15px;
  }
  .seat-row {
    display: flex;
    align-items: center;
  }
  .row-id {
    width: 20px;
    min-width: 20px;
    margin-right: 15px;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
  }
  .seat {
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    margin: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-width: 2px;
    border-style: solid;
    border-radius: 5px;
    cursor: pointer;
  }


  .screen-text {
    width: 400px;
    height: 20px;
    margin: 0 auto 20px auto;
    background: #e0e0e0;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    text-align: center;
    font-size: 20px;
    line-height: 20px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color: 'black';
  }
  


  // .notForCruzeSeat {
  //   background-color: #f5f5f5;
  //   border-color: #f8f8f8;
  //   color: rgba(200, 200, 200, 0.6);
  // }
  // .notForCruzeSeatText {
  //   color: rgba(200, 200, 200, 0.6);
  //   font-size: 12px;
  // }

  .notForCruzeSeat {
    background-color: #fff;
    border-color: red;
    // background-color: orange;
    // border: 1px solid #cc7000;
  }

  // .notForCruzeSeat {
  //   background-color: #d4f8d4; /* light green */
  //   // background-color: #fff;
  //   border: 1px solid #4caf50; /* darker green border */
  //   color: #2e7d32;            /* optional: green text */
  // }

  // .notForCruzeSeat {
  //   background-color: #ffeacc; /* soft peach */
  //   border: 1px solid #ffa726; /* orange border */
  //   color: #8a4b00;
  // }
  
  .notForCruzeSeatText {
    color: #333;
    font-size: 12px;
    // color: white;
    // font-weight: bold;
  }
  


  .availableSeat {
    background-color: #fff;
    border-color: green;
  }
  .availableSeatText {
    color: #333;
    font-size: 12px;
  }
  .bookedSeat {
    background-color: #f1f1f1;
    border-color: #f1f1f1;
  }
  .bookedSeatText {
    color: black;
    font-size: 12px;
  }
  .blockedSeat {
    background-color: #f8f8f8;
    border-color: orange;
  }
  .blockedSeatText {
    color: orange;
    font-size: 12px;
  }
  .selectedSeat {
    background-color: green !important;
    border-color: green !important;
    border-width: 3px !important;
  }
  .selectedSeatText {
    color: white !important;
    font-size: 12px;
  }
  .emptySpace {
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    margin: 4px;
    visibility: hidden;
  }
  .seatText {
    font-size: 12px;
  }

  // .cruzeBlockedSeat {
  //   background-color: #f3e5f5;
  //   border: 1px solid #8e24aa;
  // }
  
  .cruzeBlockedSeatText {
    color: #6a1b9a;
    font-size: 12px;
  }

  .cruzeBlockedSeat {
    background-color: #dbeafe;  /* Tailwind: bg-blue-100 */
    border: 1px solid #2563eb;  /* Tailwind: border-blue-600 */
    color: #2563eb;
    font-size: 10px;
  }

  .cruzeAdminSeat {
    background-color: #fff3cd;  /* Light yellow */
    border: 1px solid #ffca2c;  /* Bootstrap yellow border */
    color: #856404;             /* Dark yellow text */
    font-size: 10px;
  }
  
`;




const tooltipStyles = `
  /* Custom tooltip styles */
  .seat.blockedSeat {
    position: relative;
  }
  
  .seat.blockedSeat[title]:hover::after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 5px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    margin-bottom: 5px;
  }
  
  .seat.blockedSeat[title]:hover::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #333;
    z-index: 1000;
  }
`;
